import React from "react";
import UnifiedProfile from "../../component/UnifiedProfile";

const Profile = () => {
    return <UnifiedProfile role="seller" />;
};

export default Profile;
